import { useEffect } from 'react';
import { SITE_URL, SOCIAL_IMAGE_URL } from '../../data/seo';

const upsertMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
};

const PageSeo = ({ title, description, path, serviceName }) => {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path === '/' ? '/' : path}`;

    document.title = title;
    upsertMeta('name', 'title', title);
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:url', canonicalUrl);
    upsertMeta('property', 'og:image', SOCIAL_IMAGE_URL);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', SOCIAL_IMAGE_URL);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);

    const schemaId = 'page-service-schema';
    const existingSchema = document.getElementById(schemaId);

    if (serviceName) {
      const schema = existingSchema || document.createElement('script');
      schema.id = schemaId;
      schema.type = 'application/ld+json';
      schema.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: serviceName,
        serviceType: serviceName,
        url: canonicalUrl,
        areaServed: 'Salt Lake County, Utah',
        provider: {
          '@type': 'HVACBusiness',
          name: 'Preferred Service Heating & Air',
          url: SITE_URL,
          telephone: '+1-801-577-2442',
        },
      });

      if (!existingSchema) {
        document.head.appendChild(schema);
      }
    } else if (existingSchema) {
      existingSchema.remove();
    }
  }, [description, path, serviceName, title]);

  return null;
};

export default PageSeo;
